import { ReactNode, Ref } from "react";
import cx from "classnames";

import { useCssTransition } from "hooks/useCssTransition";
import Box from "ds/components/Box";

import styles from "./styles.module.css";

type SlideTransitionProps = {
  children: ReactNode;
  visible: boolean;
  wrapperRef?: Ref<HTMLDivElement>;
  className?: string;
  isFixed?: boolean;
};

const SlideTransition = ({
  children,
  visible,
  wrapperRef,
  className,
  isFixed,
}: SlideTransitionProps) => {
  const { shouldRender, getClassNames } = useCssTransition({
    visible,
    timeout: 300,
    unmountOnExit: true,
    appear: true,
  });

  if (!shouldRender) {
    return null;
  }

  const transitionClasses = getClassNames({
    enter: styles.enter,
    enterActive: styles.enterActive,
    exit: styles.exit,
    exitActive: styles.exitActive,
  });

  return (
    <Box
      ref={wrapperRef}
      className={cx(
        className,
        {
          [styles.fixed]: isFixed,
        },
        transitionClasses
      )}
      justify="center"
    >
      {children}
    </Box>
  );
};

export default SlideTransition;
